import type {
  OpenShiftState,
  OpenShiftNotAvailableReason,
} from '../../../components/Shifts/Common/types';
import type { BadgeVariant } from '@/components/ui/badge';

export const OPEN_SHIFT_STATE_VARIANT: Record<OpenShiftState, BadgeVariant> = {
  available: 'success',
  requested: 'warning',
  confirmed: 'info',
  'not-available': 'secondary',
};

export type SelectedOpenShift = {
  id?: string;
  name: string;
  startDate: string;
  endDate: string;
  targetName: string | null;
  breakPeriodMinutes: number;
  state: OpenShiftState;
  notAvailableReason?: OpenShiftNotAvailableReason;
  openShiftId: string;
  assignmentRequestId: string | null;
};

export const getOpenShiftStateLabels = (
  t: (key: string) => string,
): Record<OpenShiftState, string> => ({
  available: t('state.available'),
  requested: t('state.requested'),
  confirmed: t('state.confirmed'),
  'not-available': t('state.notAvailable'),
});
